import styled from "styled-components";

export const StyledUserInfo = styled.span`
  height: 130px;
  background: var(--button-color-labs);
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  .profile-wrapper {
    position: relative;
    display: inline-block;
    min-width: 80px;
    height: 80px;
    border: 1px solid var(--primary-color);
    background: var(--white-color);
    box-shadow: 0px 6px 20px 5px rgba(62, 165, 219, 0.16);
    z-index: 2;
    &::before {
      content: "";
      position: absolute;
      display: inline-block;
      width: 70px;
      height: 70px;
      background: #e7e7e8;
      border-radius: 50%;
      top: 4px;
      left: 4px;
      z-index: -1;
    }
    svg {
      height: 50px;
      width: 50px;
    }
    img {
      object-fit: cover;
      object-position: center center;
      border-radius: 50%;
      height: 70px;
      width: 70px;
    }
  }
  .user-information {
    min-height: 80px;
    margin-right: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
  .user-name {
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
  }
  .user-nid {
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
  }
`;

export const UserHistoryInfo = styled.span`
  min-height: 150px;
  background: var(--white-color);
  border-radius: 6px;
  ul {
    list-style-type: none;
    li {
      border-radius: 6px;
      height: 30px;
    }
    li:nth-child(odd) {
      background: #b0e1fb;
    }
  }
`;
